import { ref } from 'vue'
export default function useChat() {
  const groupId = ref('')
  const privateId = ref('')
  const guideConsultGroupId = ref('')
  const doctorDaGroupId = ref('')
  // 查看会话
  const lookChatHistory = data => {
    const { doctorPatientGroupId, assistantPatientGroupId, assistantDoctorGroupId } = data
    groupId.value = doctorPatientGroupId
    privateId.value = assistantPatientGroupId
    guideConsultGroupId.value = data.guideConsultGroupId
    doctorDaGroupId.value = assistantDoctorGroupId
  }
  return {
    groupId,
    privateId,
    guideConsultGroupId,
    doctorDaGroupId,
    lookChatHistory
  }
}
